import { environment } from "../../environments/environment";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { AlertController } from '@ionic/angular';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(
    private platform: Platform,
    private appVersion: AppVersion,
    private http: HttpClient,
    private alertController: AlertController,
    private iab: InAppBrowser
  ) { }

  async checkForUpdate() {
    try {
      // Aguarda a plataforma estar pronta
      await this.platform.ready();
  
      // Verifica se o Cordova está disponível
      if (!this.platform.is('cordova')) {
        console.warn('Cordova not available. Ignorando verificação de atualização.');
        return;
      }
  
      // Obtém a versão atual do app
      const currentVersion = await this.appVersion.getVersionNumber();
      console.log('Versão atual do app:', currentVersion);
      
      // Constrói a URL do endpoint de atualização usando a URL base do ambiente
      const url = `${environment.url}/version`;
      console.log('Consultando endpoint de versão:', url);
      
      // Faz a requisição GET e aguarda a resposta
      // Supondo que o endpoint retorne { minVersion: string, latestVersion: string }
      const data = await this.http.get<{ minVersion: string, latestVersion: string }>(url).toPromise();
      console.log('Versão mínima requerida recebida:', data.minVersion);
      console.log('Última versão disponível:', data.latestVersion);
  
      // Atualização obrigatória: se a versão instalada for menor que a mínima exigida
      if (this.isVersionOutdated(currentVersion, data.minVersion)) {
        const alert = await this.alertController.create({
          header: 'Atualização obrigatória',
          message: 'Uma nova versão do app está disponível e é obrigatória. Por favor, atualize para continuar.',
          backdropDismiss: false,
          buttons: [{
            text: 'Atualizar',
            handler: () => {
              this.iab.create('https://play.google.com/store/apps/details?id=com.trocadatas.app', '_system');
            }
          }]
        });
        await alert.present();
      }
      // Atualização opcional: se a versão estiver desatualizada em relação à última versão, mas já atender à versão mínima
      else if (this.isVersionOutdated(currentVersion, data.latestVersion)) {
        const alert = await this.alertController.create({
          header: 'Atualização disponível',
          message: 'Uma nova versão do app está disponível. Você pode atualizar agora ou continuar utilizando a versão atual.',
          backdropDismiss: true,
          buttons: [
            {
              text: 'Atualizar',
              handler: () => {
                this.iab.create('https://play.google.com/store/apps/details?id=com.trocadatas.app', '_system');
              }
            },
            {
              text: 'Fechar',
              role: 'cancel'
            }
          ]
        });
        await alert.present();
      }
    } catch (error) {
      console.error('Erro ao verificar a versão do app:', error);
    }
  }
  
  // Função para comparar versões
  private isVersionOutdated(current: string, target: string): boolean {
    const cur = current.split('.').map(num => parseInt(num, 10));
    const tar = target.split('.').map(num => parseInt(num, 10));
    for (let i = 0; i < Math.max(cur.length, tar.length); i++) {
      if ((cur[i] || 0) < (tar[i] || 0)) {
        return true;
      } else if ((cur[i] || 0) > (tar[i] || 0)) {
        return false;
      }
    }
    return false;
  }
}
